import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EricResponse} from '@nachdigal';
import {TranslateService} from '@ngx-translate/core';
import {EncodingHelper, noEmailInAnhaengeProvided, ObjectHelper} from '@utils-lib';
// eslint-disable-next-line
import * as FastXmlParser from 'fast-xml-parser';

@Component({
    selector: 'common-ui-eric-response',
    templateUrl: './eric-response.component.html',
    styleUrls: ['./eric-response.component.scss']
})
export class EricResponseComponent {

    @Output()
    public ericResponseSelected: EventEmitter<string> = new EventEmitter<string>();

    // TODO ERIC RESPONSE PROPOSAL. PLEASE DO NOT DELETE THE FOLLOWING LINES
    // public ericErrorMessages: Array<EricResponseView> = [];
    public ericErrorMessages: Array<string> = [];
    public infoMessage: string;
    private internalData: EricResponse;
    private parser = new FastXmlParser.XMLParser()

    constructor(private readonly translateService: TranslateService) {
        const info = translateService.instant('COMMON_UI.ERIC_RESPONSE.INFO');
        const link = translateService.instant('COMMON_UI.ERIC_RESPONSE.LINK');
        const lable = translateService.instant('COMMON_UI.ERIC_RESPONSE.LINK_LABLE');
        this.infoMessage = `${info} <a href='${link}' target='_blank'>${lable}</a>.`;
    }

    public get data(): EricResponse {
        return this.internalData;
    }

    @Input()
    public set data(value: EricResponse) {
        this.internalData = value;
        // TODO ERIC RESPONSE PROPOSAL. PLEASE DO NOT DELETE THE FOLLOWING LINES
        // this.getEricErrorMessages(this.internalData);
        this.ericErrorMessages = this.getEricErrorMessages(this.internalData);
    }

    public messageSelected(message): void {
        this.ericResponseSelected.emit(message);
    }

    // TODO ERIC RESPONSE PROPOSAL. PLEASE DO NOT DELETE THE FOLLOWING LINES
    //   private getEricErrorMessages(ericResponse: EricResponse): Array<EricResponseView> {
    //       if (!ericResponse || ericResponse.result === 0) {
    //           return [];
    //       }
    //
    //       const file = ericResponse.files.find(x => x.filename === 'eric-error.xml');
    //       if (!file) {
    //           if (ericResponse.result_string) {
    //               return [
    //                   {
    //                       id: 'FinanzamtAngaben',
    //                       value: ericResponse.result_string
    //                   }
    //               ];
    //           } else {
    //               return [];
    //           }
    //       }
    //
    //       const xml = EncodingHelper.base64DecodeUnicode(file.content);
    //       const errorJson = FastXmlParser.parse(xml);
    //
    //       console.log(errorJson);
    //
    //       const errors = errorJson.EricBearbeiteVorgang.FehlerRegelpruefung;
    //       if (errors instanceof Array) {
    //           for (const error of errors) {
    //             this.pushToEricMessages(error);
    //           }
    //       } else if (typeof errors === 'object') {
    //         this.pushToEricMessages(errors);
    //       }
    //
    //   }
    //
    // private pushToEricMessages(error: any) {
    //   this.ericErrorMessages.push({
    //     id: error.Feldidentifikator.replace('/KapG[1]/', ''),
    //     value: this.parsePlainEricMessageToReadableMessage(error.Text)
    //   });
    // }

    private getEricErrorMessages(ericResponse: EricResponse): Array<string> {
        if (!ericResponse || ericResponse.result === 0) {
            return [];
        }

        const file = ericResponse.files.find(x => x.filename === 'eric-error.xml');
        if (!file) {
            if (ericResponse.result_string) {
                return [ericResponse.result_string];
            } else {
                return [];
            }
        }

        const xml = EncodingHelper.base64DecodeUnicode(file.content);
        const errorJson = this.parser.parse(xml);

        const errorMessage = ObjectHelper.findValuesByPropertyName(errorJson, 'Text');
        return errorMessage.map((data: string) => this.parsePlainEricMessageToReadableMessage(data));
    }

    private parsePlainEricMessageToReadableMessage(plainEricText: string): string {
        const cleanString = plainEricText.replace(/(\[\d{1,}])|(('\$)|(\$'))/g, '');
        const splittedString = cleanString.split(' ');
        let shortenPath: string;
        splittedString.forEach((part, index) => {
            if (part.includes('EUn')) {
                shortenPath = /EUn(.+)/.exec(part)[0];
                splittedString[index] = shortenPath.replace('EUn/', '');
            } else if (part.includes('KapG/')) {
                shortenPath = /KapG(.+)/.exec(part)[0];
                splittedString[index] = shortenPath.replace('KapG/', '');
            } else if (part.includes('PersG')) {
                shortenPath = /PersG(.+)/.exec(part)[0];
                splittedString[index] = shortenPath.replace('PersG/', '');
            } else if (part.includes('KapGAus/')) {
                shortenPath = /KapGAus(.+)/.exec(part)[0];
                splittedString[index] = shortenPath.replace('KapGAus/', '');
            } else if (part.includes('BetPG')) {
              shortenPath = /BetPG(.+)/.exec(part)[0];
              splittedString[index] = shortenPath.replace('BetPG/', '');
            }else if (part.includes('Anhaenge')) {
              // Workaround for different Eric Validation ResponseText
              splittedString.length = 0;
              splittedString[0] = noEmailInAnhaengeProvided;
            } else {
                splittedString[index] = part;
            }
        }, splittedString);
         return splittedString.join(' ');
    }
}
